import { createAction, props } from '@ngrx/store';

import { ShortDtc } from '../../models/dtc';

export const loadDtcList = createAction(
  '[Vehicle Diagnostics] Load DTC List',
  props<{ vehicleId: number; dateRange: { start: Date; end: Date } }>(),
);

export const loadActiveLampDtc = createAction(
  '[Vehicle Diagnostics] Load Active Lamp DTC',
  props<{ vehicleId: number }>(),
);

export const loadActiveLampDtcSuccess = createAction(
  '[Vehicle Diagnostics] Load Active Lamp DTC Success',
  props<{ activeLampDtc: ShortDtc[] }>(),
);

export const loadDtcListSuccess = createAction(
  '[Vehicle Diagnostics] Load DTC List Success',
  props<{ shortDtc: ShortDtc[] }>(),
);

export const loadTooltipDtc = createAction(
  '[Vehicle Diagnostics] Load Tooltip DTC',
  props<{ vehicleId: number }>(),
);

export const loadTooltipDtcSuccess = createAction(
  '[Vehicle Diagnostics] Load Tooltip DTC Success',
  props<{ tooltipDtc: ShortDtc[] }>(),
);

export const loadMilStatus = createAction(
  '[Vehicle Diagnostics] Get MIL Status',
  props<{ vehicleId: number }>(),
);

export const loadMilStatusSuccess = createAction(
  '[Vehicle Diagnostics] Get MIL Status Success',
  props<{ milStatus: number }>(),
);
export const loadTooltipMilStatus = createAction(
  '[Vehicle Diagnostics] Get Tooltip MIL Status',
  props<{ vehicleId: number }>(),
);
export const loadTooltipMilStatusSuccess = createAction(
  '[Vehicle Diagnostics] Get Tooltip MIL Status Success',
  props<{ tooltipMilStatus: number }>(),
);

export const clearEngineLightDtc = createAction(
  '[Vehicle Diagnostics] Clear Engine Light DTC',
);

export const vehicleDiagnosticsFailure = createAction(
  '[Vehicle Diagnostics] Vehicle Diagnostics Failure',
  props<{ error: any }>(),
);
